import { axiosAPIInstance as axios } from '../axios-config';

export const ServerVersion = 1;

const clientVersion = process.env.CLIENT_VERSION;
const shouldRunClientVersionCheck = true;
let protectionCount = 0;

export function incrementVersionCheckerProtectionCount() {
  protectionCount += 1;
}

export function decrementVersionCheckerProtectionCount() {
  protectionCount -= 1;
}

async function reloadAndClearCache() {
  try {
    await axios.post(window.location.origin, undefined, { ignoreAdditionalHeaders: true });
  } catch (err) {
    console.error(`Failed to POST to origin (${window.location.origin}) - error below`);
    console.error(err);
  }

  // Fallback
  setTimeout(() => {
    try {
      window.location.href = `${window.location.origin}?fix=${Date.now()}`;
    } catch (err) {
      console.error(err);
    }
  }, 16);
}

export async function fetchPublishedClientVersion() {
  let tgUrl = window.location.origin;
  if (!tgUrl.endsWith('/')) tgUrl += '/';
  tgUrl += `version.txt?unique=${Date.now().toString()}`;

  const resp = await axios.get(tgUrl, { ignoreAdditionalHeaders: true });
  return resp.data;
}

let isWaitingForRefresh = false;
export function attemptReload(msg, force = false) {
  if (force) {
    isWaitingForRefresh = false;
    protectionCount = 0;
  }

  if (isWaitingForRefresh) return;
  if (protectionCount === 0) {
    // eslint-disable-next-line no-alert
    alert(`${msg}. The application will now refresh.`);
    reloadAndClearCache();
  } else {
    // eslint-disable-next-line no-alert
    alert(`${msg}. The application will refresh when you leave the current page.`);
    isWaitingForRefresh = true;
    setInterval(() => {
      if (isWaitingForRefresh && protectionCount === 0) {
        reloadAndClearCache();
      }
    }, 1000);
  }
}

// TODO: Remove these - this is for debugging
window.incrementProtectionCount = incrementVersionCheckerProtectionCount;
window.decrementProtectionCount = decrementVersionCheckerProtectionCount;
window.attemptReload = attemptReload;

export async function initializeClientVersionCheck() {
  if (!shouldRunClientVersionCheck) return;

  console.log(`Using client version ${clientVersion}`);

  // Run the check every minute
  const intervalSeconds = 60;

  const check = async() => {
    try {
      const version = await fetchPublishedClientVersion();
      if (version !== clientVersion) {
        attemptReload('There has been an application update');
      }
    } catch (er) {
      console.error(er);
    }
  };

  await check();
  setInterval(check, intervalSeconds * 1000);
}




// WEBPACK FOOTER //
// ./src/utils/version.js